import { createTheme } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import { faIR } from "@material-ui/core/locale";

export const borderRadius = "15px !important";
export const backGroundColor = "#55d6fd";
export const backGroundColorTopic = "#f7f6f4";
export const blueColor = "#169fd5";
export const sampleShadow = "0px 0px 15px -6px rgba(0,0,0,0.2)";
export const colorCaption = "#a0a0a0";
export const fontFamily = "IRANSans";

export default createTheme(
  {
    palette: {
      primary: {
        main: blueColor,
      },
      secondary: blue,
      caption: colorCaption,
      cardBorder: "#efefef",
      blueColor: blueColor,
      backBlueColor: backGroundColor,
    },
    overrides: {
      MuiCard: {
        root: {
          boxShadow: sampleShadow,
        },
      },
      MuiPaper: {
        rounded: {
          borderRadius: borderRadius,
        },
      },
      MuiAppBar: {
        root: {
          backgroundColor: "white !important",
          color: "#666666 !important",
        },
      },
    },
    props: {
      // Style sheet name ⚛️
      MuiButton: {
        // Name of the rule
        text: {
          // Some CSS
          color: "#ff0000",
        },
      },
    },
    borderSetRadius: borderRadius,
    sampleShadow: sampleShadow,
    card: {
      backBlueColor: backGroundColor,
      backCardCss: {
        position: "absolute",
        top: 0,
        left: 0,
        backgroundColor: backGroundColor,
        width: "100%",
        height: "100%",
        borderRadius: borderRadius,
        zIndex: -1,
        transform: "rotate(0.8deg)",
        boxShadow: "none",
      },
    },
    questionBox: {
      card: {
        borderRadius: borderRadius,
        boxShadow: sampleShadow,
        border: "none",
        width: "100%",
      },
      topicBox: {
        backgroundColor: backGroundColorTopic,
        color: blueColor,
        borderRadius: borderRadius,
        paddingLeft: 8,
        paddingRight: 8,
        marginLeft: 6,
        paddingTop: 2,
        paddingBottom: 2,
        height: "100%",
        fontSize: 11,
      },
    },
    status: {
      danger: "orange",
    },
    direction: "rtl",
    typography: {
      fontFamily: fontFamily,
    },
    spacing: 8,
    Button: {
      fontFamily: fontFamily,
    },
  },
  faIR,
);
